// No-op shim for react-native-reanimated on web.
// The app does not use Reanimated directly; this shim prevents
// webpack warnings from react-native-gesture-handler's optional import.
export const useSharedValue = (init: unknown) => ({ value: init });
export const useAnimatedStyle = (fn: () => unknown) => fn();
export const withTiming = (toValue: unknown) => toValue;
export const withSpring = (toValue: unknown) => toValue;
export const runOnJS = (fn: (...args: unknown[]) => void) => fn;
export const Easing = { linear: (t: number) => t };
export const Animated = { View: require('react-native').View };
export default { useSharedValue, useAnimatedStyle, withTiming, withSpring, runOnJS, Easing, Animated };
